<template>
  <b-form-input
    :value="localValue"
    @input="onInput"
    @keypress="onlyNumbers"
    @paste="handlePaste"
    type="text"
  />
</template>

<script>

export default {
  name: 'InputNumber',

  props: {
    value: {
      type: [String, Number],
      default: ''
    },

    decimal: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    localValue() {
      const str = String(this.value)
      if (this.decimal) {
        return str
          .replace(/[^0-9.]/g, '') // solo números y punto
          .replace(/^\./, '') // elimina punto inicial
          .replace(/(\..*?)\..*/g, '$1') // solo un punto
      }
      return str.replace(/\D/g, '') // solo números
    }
  },

  methods: {
    // onlyNumbers, // tu helper externo

    onlyNumbers(e) {
      const char = String.fromCharCode(e.which)
      const isNumber = /[0-9]/.test(char)
      const isDot = char === '.'

      if (this.decimal) {
        const currentValue = e.target.value

        if (isDot) {
          // impide más de un punto o punto al inicio
          if (currentValue.includes('.') || currentValue.length === 0) {
            e.preventDefault()
          }
        } else if (!isNumber) {
          e.preventDefault()
        }
      } else {
        if (!/[0-9]/.test(char)) {
          e.preventDefault()
        }
      }
    },

    onInput(value) {
      this.$emit('input', value)
    },

    handlePaste(event) {
      event.preventDefault()
      const clipboardData = event.clipboardData || window.clipboardData
      const pastedData = clipboardData.getData('text').replace(/\D/g, '')
      // Emitimos solo los números pegados
      this.$emit('input', pastedData)
    }
  }
}
</script>
